import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * CRM-managed emoji for the Design / Construction / Office groups, shown on the
 * portal section headers for SOPs and Job Descriptions. Edited from the CRM
 * templates pages; stored one doc per scope in `portalGroupEmojis`.
 */
const DEFAULTS = {
  sop: { design: '📐', construction: '👷', office: '🏢', 'contact-to-build': '📋' },
  jobDescription: { design: '📐', construction: '👷', office: '🏢' },
  kpi: { design: '📐', construction: '👷', office: '🏢' },
};

const refFor = (scope) => doc(db, 'portalGroupEmojis', scope);

export function defaultGroupEmojis(scope) {
  return { ...(DEFAULTS[scope] || DEFAULTS.sop) };
}

export async function fetchGroupEmojis(scope) {
  try {
    const snap = await getDoc(refFor(scope));
    if (snap.exists()) {
      return { ...defaultGroupEmojis(scope), ...snap.data() };
    }
  } catch (err) {
    console.error('Error fetching group emojis:', err);
  }
  return defaultGroupEmojis(scope);
}

/** Save one group's emoji; returns the merged emoji map. */
export async function saveGroupEmoji(scope, groupId, emoji, current) {
  const next = { ...(current || {}), [groupId]: emoji };
  await setDoc(refFor(scope), { [groupId]: emoji, updatedAt: serverTimestamp() }, { merge: true });
  return next;
}
